<template>
    <div class="modal-card card">
        <div class="card-header">
            <h4 class="card-header-title">{{ title }}</h4>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="card-body">
            <div class="text-muted">
                {{ description }}
            </div>
        </div>

        <div class="card-footer d-flex justify-content-end gap-2">
            <button type="button" class="btn btn-secondary" :disabled="loading" @click="onCancel">
                Cancel
            </button>
            <button type="button" class="btn btn-outline-primary" :disabled="loading" @click="onSelect('CNAME')">
                <span v-if="loadingMethod === 'CNAME'" class="spinner-border spinner-border-sm me-2" role="status"
                    aria-hidden="true"></span>
                {{ cnameLabel }}
            </button>
            <button type="button" class="btn btn-primary" :disabled="loading" @click="onSelect('DNS_TXT')">
                <span v-if="loadingMethod === 'DNS_TXT'" class="spinner-border spinner-border-sm me-2" role="status"
                    aria-hidden="true"></span>
                {{ txtLabel }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    name: "DomainRefreshMethod",
    props: {
        modalData: {
            type: Object,
            default: null,
        },
    },
    computed: {
        title() {
            return this.modalData?.title ?? "Refresh DNS records";
        },
        description() {
            return this.modalData?.description ?? "Please choose the validation method to be used for validation.";
        },
        cnameLabel() {
            return this.modalData?.cnameLabel ?? "DNS CNAME";
        },
        txtLabel() {
            return this.modalData?.txtLabel ?? "DNS TXT";
        },
        loading() {
            return Boolean(this.loadingMethod);
        },
    },
    data() {
        return {
            loadingMethod: null,
        };
    },
    methods: {
        onCancel() {
            if (typeof this.modalData?.onCancel === "function") {
                this.modalData.onCancel();
            }
            this.$store.dispatch("hideModal");
        },
        async onSelect(method) {
            this.loadingMethod = method;
            try {
                if (typeof this.modalData?.onSelect === "function") {
                    await this.modalData.onSelect(method);
                }
            } finally {
                this.loadingMethod = null;
            }
        },
    },
};
</script>

